// useMesh — accessor for the MeshContext value.
//
// Throws if used outside <MeshProvider> — consistent with useIdentity. A
// missing provider in a real render tree is a programming error, not a
// runtime fallback we should paper over with a silent default.

import { useContext } from 'react';
import { MeshContext } from '../providers/MeshProvider';

/**
 * @returns {{
 *   mesh: import('../lib/p2p/PeerMesh').PeerMesh | null,
 *   status: 'idle' | 'connecting' | 'connected' | 'failed',
 *   peers: Array<{ userId: string, handle: string, avatarSeed: string, lastSeen: number, publicIp: string | null, deviceType: 'phone' | 'monitor' }>,
 *   connectionsByPeer: Record<string, RTCPeerConnection | null>,
 *   pendingOffers: Array<{ id: string, name: string, size: number, mime: string, fromId: string, ts: number }>,
 *   startSend: (file: File | Blob, toPeerId: string) => any,
 *   sendCodeEnvelope: (env: object, toPeerId?: string) => number,
 *   acceptOffer: (id: string) => void,
 *   declineOffer: (id: string, opts?: { block?: boolean }) => void,
 *   subscribeCodeEnvelopes: (cb: (env: object, fromPeerId: string) => void) => () => void,
 * }}
 */
export function useMesh() {
  const ctx = useContext(MeshContext);
  if (ctx === null || ctx === undefined) {
    throw new Error('useMesh must be used within a <MeshProvider>');
  }
  return ctx;
}

export default useMesh;
